import Skeleton from '@mui/material/Skeleton';

export default function SkeletonIndications() {
    // Criamos um array de 3 itens para representar o carregamento do feed
    const loaders = [1, 2, 3];

    return (
        <div className="w-full max-w-4xl mx-auto space-y-6">
            {loaders.map((key) => (
                <div 
                    key={key} 
                    className="bg-gray-300 dark:bg-[#001e42] rounded-3xl shadow-sm border border-gray-100 dark:border-white/5 overflow-hidden animate-pulse"
                >
                    {/* Header do Skeleton */}
                    <div className="px-6 py-4 flex items-center border-b border-gray-50 dark:border-white/5">
                        <div className="flex items-center gap-3">
                            <Skeleton 
                                variant="circular" 
                                width={40} 
                                height={40} 
                                sx={{ bgcolor: 'rgba(255,255,255,0.1)' }} 
                            />
                            <div className="space-y-2">
                                <Skeleton 
                                    variant="text" 
                                    width={120} 
                                    height={15} 
                                    sx={{ bgcolor: 'rgba(255,255,255,0.1)' }} 
                                />
                                <Skeleton 
                                    variant="text" 
                                    width={80} 
                                    height={10} 
                                    sx={{ bgcolor: 'rgba(255,255,255,0.05)' }} 
                                />
                            </div>
                        </div>
                    </div>

                    {/* Corpo do Skeleton */}
                    <div className="p-6">
                        <div className="flex flex-col md:flex-row gap-6">
                            
                            {/* Capa do Livro Skeleton */}
                            <div className="shrink-0">
                                <Skeleton 
                                    variant="rounded" 
                                    width={96} 
                                    height={144} 
                                    sx={{ borderRadius: '8px', bgcolor: 'rgba(255,255,255,0.1)' }} 
                                />
                            </div>

                            {/* Conteúdo de Texto Skeleton */}
                            <div className="flex-1 space-y-4">
                                <div className="space-y-2">
                                    <Skeleton 
                                        variant="text" 
                                        width="60%" 
                                        height={25} 
                                        sx={{ bgcolor: 'rgba(255,255,255,0.1)' }} 
                                    />
                                    <Skeleton 
                                        variant="text" 
                                        width="30%" 
                                        height={15} 
                                        sx={{ bgcolor: 'rgba(255,255,255,0.05)' }} 
                                    />
                                </div>
                                
                                <div className="space-y-2">
                                    <Skeleton 
                                        variant="rectangular" 
                                        width="100%" 
                                        height={60} 
                                        sx={{ borderRadius: '12px', bgcolor: 'rgba(255,255,255,0.03)' }} 
                                    />
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Footer do Skeleton */}
                    <div className="px-6 py-3 bg-gray-50/50 dark:bg-black/10 flex items-center gap-6 border-t border-gray-50 dark:border-white/5">
                        <Skeleton 
                            variant="text" 
                            width={80} 
                            height={25} 
                            sx={{ bgcolor: 'rgba(255,255,255,0.05)' }} 
                        />
                        <Skeleton 
                            variant="text" 
                            width={100} 
                            height={25} 
                            sx={{ bgcolor: 'rgba(255,255,255,0.05)' }} 
                        />
                    </div>
                </div>
            ))}
        </div>
    );
}